import React, { FC } from 'react';

const Arrow: FC<{ color?: string }> = ({ color = '#136FD8' }) => {
  return (
    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" style={{ color: color }}>
      <path
        d="M0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L3.29289 4L0.146447 7.14645C-0.0488153 7.34171 -0.0488152 7.65829 0.146447 7.85355C0.341709 8.04882 0.658292 8.04882 0.853554 7.85355L4.35355 4.35355C4.54882 4.15829 4.54882 3.84171 4.35355 3.64645L0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Arrow;
